module.exports = __webpack_public_path__ + "img/construction.54ae472a.webp";